export function replaceAllEnterWithSpace(str) {
  return str.replace(/(?:\r\n|\r|\n)/g, ' ');
}